import { FC, useState, useRef } from 'react';
import { createPortal } from 'react-dom';

const TOOLTIP_WIDTH = 200;
const TOOLTIP_GAP = 8;

export const Tooltip: FC<{ children: React.ReactNode; text: string; placement?: 'top' | 'bottom' }> = ({
  text,
  children,
  placement = 'bottom',
}) => {
  const [hover, setHover] = useState(false);
  const ref = useRef<HTMLSpanElement | null>(null);
  const [coords, setCoords] = useState({ top: 0, left: 0, placeAbove: false });

  const handleEnter = () => {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();
    const placeAbove = placement === 'top';
    let left = rect.right - TOOLTIP_WIDTH;
    left = Math.max(8, Math.min(left, window.innerWidth - TOOLTIP_WIDTH - 8));

    setCoords({
      top: placeAbove ? rect.top - TOOLTIP_GAP : rect.bottom + TOOLTIP_GAP,
      left,
      placeAbove,
    });
    setHover(true);
  };

  return (
    <>
      <span ref={ref} onMouseEnter={handleEnter} onMouseLeave={() => setHover(false)} className="inline-block">
        {children}
      </span>

      {hover &&
        createPortal(
          <div
            className="fixed z-popover w-[200px] bg-white p-[6px_10px] rounded-chip text-ui text-ink shadow-popup border border-primary/50"
            style={{
              top: coords.top,
              left: coords.left,
              transform: coords.placeAbove ? 'translateY(-100%)' : undefined,
            }}
          >
            {text}
          </div>,
          document.body,
        )}
    </>
  );
};
